import {logInProduction} from '$lib/utils/logInProduction';

export class Timer {

    start: number

    constructor(private readonly name: string) {
        this.start = Date.now()
    }

    stop() {
        const end = Date.now()
        logInProduction(`${this.name}: ${end - this.start}`)
    }
}